export default __webpack_public_path__ + "static/210-f8f284e39b31a0e79d096d7e9c56e11b.gif";